import { ReactComponent as CheckIcon } from 'components/v2/Icons/svg/check.svg';
import { ChipRoot } from './SelectableChip.styles';

export default function SelectableChip({ label, selected, onClick }) {
  return (
    <ChipRoot
      selected={selected}
      onClick={onClick}
      onKeyDown={e => (e.key === 'Enter' || e.key === ' ') && (e.preventDefault(), onClick())}
      role="button"
      tabIndex={0}
      aria-pressed={selected}
    >
      {selected && <CheckIcon width={16} height={16} />}
      {label}
    </ChipRoot>
  );
}
